<template>
  <button @click="submit()" type="button" class="circle" :class="iconClass" v-tooltip.bottom="tooltip" :style="{backgroundColor, color}"></button>
</template>

<script>
  import gridCell from '../../../mixins/gridCell';

  export default {
    mixins: [gridCell],
    props: {
      iconClass: {type: String},
      tooltip: {type: String},
      backgroundColor: {type: String},
      color: {type: String},
      confirm: {type: String}
    },
    methods: {
      submit() {
        const promise = this.confirm ? this.$dialog.confirm(this.confirm) : Promise.resolve();
        return promise.then(() => this.$emit('click', this.row, this.index));
      }
    }
  };
</script>

<style scoped>

</style>
